const sdkUrls = {
    ios: 'https://github.com/alan-ai/alan-sdk-ios/releases',
    android: 'https://github.com/alan-ai/alan-sdk-android/releases',
};

export default sdkUrls;